Vue.component('input-with-search', {
    props: {
        street: {
            type: Number,
        }
    },
    data() {
        return {
            selectedStreetId: null,
            // state
            isSeenContextMenu: false,

            // data
            allStreets: [],
            inputValue: ''
        }
    },
    computed: {
        filteredStreets() {
            if (this.inputValue) {
                return this.allStreets.filter(el => {
                    return el.name.toLowerCase().includes(this.inputValue.toLowerCase())
                })
            }
            return this.allStreets
        }
    },
    methods: {
        getStreets() {
            let vm = this
            axios.get('/cart/get-streets')
                .then(function(response) {
                    vm.allStreets = response.data
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        toggleSeenContextMenu() {
            if (this.isSeenContextMenu) {
                this.isSeenContextMenu = false
            } else {
                this.isSeenContextMenu = true
            }
        },
        closeContextMenu() {
            this.isSeenContextMenu = false
            this.processStreetInput()
        },
        filterStreet() {
            this.isSeenContextMenu = true
        },
        selectStreet(street) {
            this.isSeenContextMenu = false
            this.inputValue = street.name
            this.selectedStreetId = street.id
            this.$emit('change-street', street)
        },
        processStreetInput: function() {
            if (this.selectedStreetId) {
                let street = this.allStreets.find(el => el.id === this.selectedStreetId);
                this.inputValue = street.name;
            } else {
                this.inputValue = ''
            }
        }
    },
    created() {
        this.selectedStreetId = this.street;
        this.getStreets()
    },

    template: `
    <div class="input__search__wrapper" v-click-outside="closeContextMenu">
        <input type="text" placeholder="Адрес" v-model="inputValue" @input="filterStreet" autocomplete="new-password" @click.self="toggleSeenContextMenu">
        <div class="input__search__wrapper__context__menu" v-if="isSeenContextMenu">
            <div class="input__search__wrapper__context__menu__item" v-for="street in filteredStreets" :key="street.id" @click="selectStreet(street)">{{ street.name }}</div>
        </div>
    </div>
    `
});